import { CSSObject } from "@emotion/react";

import { useEffect, useState } from "react";

import { Trans, useTranslation } from "react-i18next";

import InfoIconWithTooltip from "@/components/IconsWithTooltips/InfoIconWithTooltip/InfoIconWithTooltip";
import { useChangeSelectedCompanyStore } from "@/stores/useChangeSelectedCompanyStore";
import { useDashboardStore } from "@/stores/useDashboardStore";

import TabsCustom from "../../../../components/TabsCustom/TabsCustom";
import { useMediaQueries } from "../../../../shared";
import CardWrapper from "../../CardWrapper/CardWrapper";
import ChartWrapper from "../../shared/ChartWrapper/ChartWrapper";
import DeviceStatus from "../../shared/DeviceStatus/DeviceStatus";
import { useStyles } from "../../styles";
import { CONNECTIVITY_TABS } from "../../types";
import CCStatus from "./CCStatus/CCStatus";

const Connectivity = () => {
  const { t } = useTranslation();
  const { toSm } = useMediaQueries();

  const {
    isDashboardLoading,
    deviceStatusError,
    ccStatusError: companyStatusError
  } = useDashboardStore();

  const isChangeSelectedCompany = useChangeSelectedCompanyStore(
    state => state.isChangeSelectedCompany
  );

  const [value, setValue] = useState(0);
  const [memoiseDevicesData, setMemoiseDevicesData] = useState<boolean>(false);
  const [memoiseCCData, setMemoiseCCData] = useState<boolean>(false);
  const [showBackButton, setShowBackButton] = useState<boolean>(false);
  const [backButton, setBackButton] = useState<Element | null>(null);

  const { connectivityTabsBox, connectivityCustomTabs } = useStyles();

  const tabsArray = [CONNECTIVITY_TABS.Devices, CONNECTIVITY_TABS.CompanyCards];
  const TAB_HEIGHT = "36px";

  useEffect(() => {
    if (isChangeSelectedCompany) {
      setValue(0);
      setMemoiseCCData(false); // Reset Company Cards data when the user changes the selected company
    }
    value === 1 && !memoiseDevicesData && setMemoiseDevicesData(true); // Memoise devices data only when the user toggles the Company Cards tab
  }, [isChangeSelectedCompany, memoiseDevicesData, value]);

  const removeBackButton = () => {
    setShowBackButton(false);
    setBackButton(null);
  };

  return (
    <CardWrapper
      isTopSection={!toSm}
      cardTitle={t("Dashboard##connectivity")}
      isError={deviceStatusError || companyStatusError}
      isInnerCard
      isLoading={isDashboardLoading}
      titleInlineAction={showBackButton && <>{backButton}</>}
      titleExtention={
        <InfoIconWithTooltip
          title={<Trans i18nKey="Dashboard##card tooltips##connectivity" />}
          iconTestId="connectivity-info icon"
          tooltipSize="medium"
        />
      }
    >
      <TabsCustom
        setValue={setValue}
        value={value}
        tabsArray={tabsArray}
        tabCustomStyle={connectivityCustomTabs as CSSObject}
        translationKey="Dashboard##connectivity tabs##"
        customTabsHolderStyle={{ width: "100%" }}
        customStyle={{ connectivityTabsBox, height: TAB_HEIGHT }}
        hasAccess
        tabIndicatorBottom="8px"
        resetDefaultView={removeBackButton}
      />
      {value === 0 && (
        <ChartWrapper>
          <DeviceStatus
            hasCardWrapper={false}
            memoiseDevicesData={memoiseDevicesData}
            setShowBackButton={setShowBackButton}
            setBackButton={setBackButton}
            activeTab={CONNECTIVITY_TABS.Devices}
          />
        </ChartWrapper>
      )}
      {value === 1 && (
        <ChartWrapper>
          <CCStatus
            memoiseCCData={memoiseCCData}
            setMemoiseCCData={setMemoiseCCData}
            setShowBackButton={setShowBackButton}
            setBackButton={setBackButton}
            activeTab={CONNECTIVITY_TABS.CompanyCards}
          />
        </ChartWrapper>
      )}
    </CardWrapper>
  );
};

export default Connectivity;
